<script>
export default {
  name: 'GoalIndicator',
  props: {
    goal: { type: Object, required: true },
    fontSize: { type: String, default: 'text-3xl' },
  },
  data() {
    return {
      goalTypes: {
        kyndness: { title: 'PENCIL Positives', color: '#1EC1A1', prefix: '' },
        volunteered: { title: 'Volunteer Hours', color: '#DE3C7A', prefix: '' },
        donation: { title: 'In-Kind Donations', color: '#FF995A', prefix: '$' },
      },
      radius: 65,
    }
  },
  computed: {
    goalColor() {
      return this.goalTypes[this.goal.type].color
    },
    goalName() {
      return this.goalTypes[this.goal.type].title
    },
    goalValuePrefix() {
      return this.goalTypes[this.goal.type].prefix
    },
    percent() {
      const { goal, achieved } = this.goal
      if (achieved === 0) {
        return 0
      }
      if (goal === 0 && achieved > 0) {
        return 1
      }
      if ((achieved / goal).toFixed(2) > 1) {
        return 1
      }
      return (achieved / goal).toFixed(2)
    },
    strokeDasharray() {
      return (
        Math.PI * 2 * this.radius * this.percent +
        ' ' +
        Math.PI * 2 * this.radius * (1 - this.percent)
      )
    },
  },
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
}
</script>

<template>
  <div class="w-45 text-center ml-11">
    <div class="h-45 bg-white rounded-full overflow-hidden relative">
      <svg width="180" height="180" viewbox="0 0 180 180">
        <circle
          cx="90"
          cy="90"
          :r="radius"
          stroke-width="5"
          stroke="#e9e9e9"
          fill="none"
        ></circle>
        <circle
          cx="90"
          cy="90"
          :r="radius"
          stroke-width="30"
          :stroke="goalColor"
          fill="none"
          transform="matrix(0,-1,1,0,0,180)"
          :stroke-dasharray="strokeDasharray"
        ></circle>
      </svg>
      <span
        class="w-24 h-24 rounded-full leading-37 absolute inset-0 m-9 bg-white text-center"
        :class="fontSize"
      >
        {{ goalValuePrefix }}{{ numberWithCommas(goal.achieved) }}
      </span>
    </div>
    <span class="text-blue-darker text-xl">{{ goalName }}</span>
  </div>
</template>
